import React, {useState} from 'react';
import {Link, NavigateFunction, useNavigate} from 'react-router-dom';

const StepInfo = () => {
  const navigate = useNavigate();
  const [steps, setSteps] = useState('stepOne');
  return (
    <div className="w-full h-full flex-col justify-center items-center px-3 py-4">
      <Link
        className="text-gray-600 text-lg no-underline font-DemiBold"
        to={'/auth/login'}
      >
        ورود به سامانه
      </Link>
      {stepsComponents[steps]({setSteps, navigate})}
    </div>
  );
};

export default StepInfo;
interface SetStepsProps {
  navigate: NavigateFunction;
  setSteps: React.Dispatch<React.SetStateAction<string>>;
}
const stepsComponents: Record<
  string,
  ({setSteps}: SetStepsProps) => JSX.Element
> = {
  stepOne: ({setSteps}) => (
    <div className="flex gap-3 w-full h-full flex-col justify-center items-center">
      <img
        alt="stepOne"
        src="https://s3.ir-thr-at1.arvanstorage.ir/shop-login/stepOne.svg"
      />
      <h3 className="text-gray-900 font-Medium text-md">
        ثبت آگهی فروش محصولات و خدمات{' '}
      </h3>
      <div className="text-md font-Regular text-gray-900 px-3">
        می‌توانید کود، سم، بذر، ماشین‌آلات و ادوات کشاورزی، زمین، باغ، گلخانه
        و... را به فروش و اجاره بگذارید.
      </div>
      <div className="flex items-center gap-1">
        <div
          onClick={() => setSteps('stepFour')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepThree')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepTwo')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepOne')}
          className="rounded-full flex h-[6px] w-[6px] bg-farm-shop-500"
        />
      </div>
      <button
        onClick={() => setSteps('stepTwo')}
        className="flex mx-5 w-full my-5 bg-farm-shop-500 h-[40px] bg-[] items-center justify-center text-white font-Medium text-sm rounded-[8px]"
      >
        بعدی
      </button>
    </div>
  ),
  stepTwo: ({setSteps}) => (
    <div className="flex gap-3 w-full h-full flex-col justify-center items-center">
      <img
        alt="stepTwo"
        src="https://s3.ir-thr-at1.arvanstorage.ir/shop-login/stepTwo.svg"
      />
      <h3 className="text-gray-900 font-Medium text-md">
        ارتباط مستقیم با کشاورزان
      </h3>
      <div className="text-md font-Regular text-gray-900 px-3">
        این امکان وجود دارد که با کشاورزان بصورت مستقیم در ارتباط باشید و از
        نیازهای آن‌ها با خبر شوید.
      </div>
      <div className="flex items-center gap-1">
        <div
          onClick={() => setSteps('stepFour')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepThree')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepTwo')}
          className="rounded-full flex h-[6px] w-[6px] bg-farm-shop-500"
        />
        <div
          onClick={() => setSteps('stepOne')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
      </div>
      <button
        onClick={() => setSteps('stepThree')}
        className="flex mx-5 w-full my-5 bg-farm-shop-500 h-[40px] bg-[] items-center justify-center text-white font-Medium text-sm rounded-[8px]"
      >
        بعدی
      </button>
    </div>
  ),
  stepThree: ({setSteps}) => (
    <div className="flex gap-3 w-full h-full flex-col justify-center items-center">
      <img
        alt="stepThree"
        src="https://s3.ir-thr-at1.arvanstorage.ir/shop-login/stepThree.svg"
      />
      <h3 className="text-gray-900 font-Medium text-md">ثبت فروشگاه اختصاصی</h3>
      <div className="text-md font-Regular text-gray-900 px-3">
        فروشگاه خود را ثبت کنید و بصورت هوشمند با خریدران واقعی ارتباط بگیرید و
        بیشتر دیده شوید.
      </div>
      <div className="flex items-center gap-1">
        <div
          onClick={() => setSteps('stepFour')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepThree')}
          className="rounded-full flex h-[6px] w-[6px] bg-farm-shop-500"
        />
        <div
          onClick={() => setSteps('stepTwo')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepOne')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
      </div>
      <button
        onClick={() => setSteps('stepFour')}
        className="flex mx-5 w-full my-5 bg-farm-shop-500 h-[40px] bg-[] items-center justify-center text-white font-Medium text-sm rounded-[8px]"
      >
        بعدی
      </button>
    </div>
  ),
  stepFour: ({navigate, setSteps}) => (
    <div className="flex gap-3 w-full h-full flex-col justify-center items-center">
      <img
        alt="stepFour"
        src="https://s3.ir-thr-at1.arvanstorage.ir/shop-login/stepFour.svg"
      />
      <h3 className="text-gray-900 font-Medium text-md">
        همرسانی عرضه و تقاضا و برندینگ هوشمند
      </h3>
      <div className="text-md font-Regular text-gray-900 px-3">
        مزرعه می‌داند که کشاورزان الان به چه خدمات و نهاده‌هایی نیاز دارند و شما
        چه چیزی را عرضه می‌کنید.
      </div>
      <div className="flex items-center gap-1">
        <div
          onClick={() => setSteps('stepFour')}
          className="rounded-full flex h-[6px] w-[6px] bg-farm-shop-500"
        />
        <div
          onClick={() => setSteps('stepThree')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepTwo')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
        <div
          onClick={() => setSteps('stepOne')}
          className="rounded-full flex h-[6px] w-[6px] bg-gray-500"
        />
      </div>
      <button
        onClick={() => navigate('/auth/login')}
        className="flex mx-5 w-full my-5 bg-farm-shop-500 h-[40px] bg-[] items-center justify-center text-white font-Medium text-sm rounded-[8px]"
      >
        ورود به فروشگاه{' '}
      </button>
    </div>
  ),
};
